require('./accountsBoxHeader.scss');

// @vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const { Link } = require('react-router-dom');

// @core
const { FormattedText, getLanguage, formatText } = require('core/i18n').i18n;

//@components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const OKTag = require('components/commons/OKTag/OKTag');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const WebappRender = require('components/conditionalRender/webappRender')

// @commons
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');


class AccountsBoxHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCopyIbanToClipBoard = this.handleCopyIbanToClipBoard.bind(this);
    }

    buildTooltipContent(iban) {
        return (
            <span>
                {iban}
                <button
                    className="accounts-box-header__tooltip-copy-button icon__tooltip icon-copiar"
                    onClick={this.handleCopyIbanToClipBoard}
                />
            </span>
        );
    }

    handleCopyIbanToClipBoard(e) {
        const iban = this.props.immAccount.get('iban');
        this.props.copyIbanToClipboard(iban);
        e.stopPropagation();
    }

    buildIsBlockedTag() {
        const { immAccount } = this.props;
        const isInactiveAccount = immAccount.get('isInactiveAccount');

        let isBlockedTag;

        if (isInactiveAccount) {
            isBlockedTag = (
                <span className="accounts-box-header__blocked-tag">
                    <OKTag
                        content="accountsAccount-blocked"
                        type="warning"
                        emphasis={true}
                    />
                </span>
            );
        }

        return isBlockedTag;
    }

    render() {
        const { immAccount, index, expanded, isBalanceDrawn } = this.props;
        const accountId = immAccount.get('accountId');
        const iban = immAccount.get('iban');
        const accountProduct = immAccount.get('catalogData').get('product');
        const accountSubType = immAccount.get('catalogData').get('subtype');
        const accountSubTypeWithSeparator = !accountProduct ? accountSubType : ' - ' + accountSubType;
        const alias = immAccount.get('alias') || accountSubType;
        const ibanTarget = __CONTACT_CENTER__ ? iban : getLastNChars(iban);
        const ibanFormatted = <span className="accounts-box-header__iban">{ibanTarget}</span>;
        const tooltipContent = this.buildTooltipContent(iban);
        const aliasLinkClasses = classnames('accounts-box-header__alias', { 'accounts-box-header__alias--is-expanded': expanded });
        const accountBalance = isBalanceDrawn
            ? immAccount.get('balanceDrawn')
            : immAccount.get('balance')
        const plainAmountObject = getPlainAmountObject(accountBalance);
        const isCanceled = immAccount.getIn(['filters', 'canceled']);
        const isBlockedTag = this.buildIsBlockedTag();
        const tagsWrapperCC = classnames({
            'accounts-box-header__tags-wrapper-cc': __CONTACT_CENTER__,
        });


        const pullRight = (
            <div className="pull-right">
                <div>
                    <FormattedText className="accounts-box-header__balance-title" value="accountsAccount-balance" />
                </div>
                <div>
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        className="accounts-box-header__balance-value"
                        amountId={'lblAvailableAmount' + index}
                        currencyId={'lblAvailableCurrency' + index}
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </div>
            </div>
        );

        const tag = (
            <div className="accounts-box-header__canceled-tag pull-right">
                <OKTag content={formatText('commons-canceled')} type="disabled" />
                {/* <OKHeaderTag value={formatText('commons-canceled')} modifier="danger"/> */}
            </div>
        );
        
        const contactCenterRightContent = (isCanceled) ? tag : pullRight;

        return (
            <div className="accounts-box-header" id={'account-box-header' + index}>
                <section>
                    <div className="accounts-box-header__column">
                        <div>
                            <div className={tagsWrapperCC}>
                                <Link
                                    className={aliasLinkClasses}
                                    to={'/myprofile/accounts/' + accountId + '/movements'}
                                >
                                    {alias}
                                </Link>
                                <OKTag
                                    content={`interventionTypes-${immAccount.get('interventionType')}`}
                                    context="arrow"
                                />
                            </div>
                            {isBlockedTag}
                        </div>
                        <div className="accounts-box-header__wrapper-iban">
                            <OKTooltip
                                content={tooltipContent}
                                offset={[50, 10]}
                                placement="bottom"
                                target={ibanFormatted}
                            />
                        </div>
                    </div>
                    <ContactCenterRender>
                        {contactCenterRightContent}
                    </ContactCenterRender>
                    <WebappRender>
                        {pullRight}
                    </WebappRender>
                    <div className="clearfix"/>
                </section>
                <section>
                    { accountProduct && (
                        <span className="accounts-box-header__type">
                            {accountProduct}
                        </span>
                    )}
                    { accountSubType && (
                        <span className="accounts-box-header__subtype">
                            {accountSubTypeWithSeparator}
                        </span>
                    )}
                </section>
            </div>
        );
    }
}

AccountsBoxHeader.propTypes = {
    immAccount: PropTypes.object,
    index: PropTypes.number,
    copyIbanToClipboard: PropTypes.func.isRequired,
    expanded: PropTypes.bool,
    isBalanceDrawn: PropTypes.bool
};

module.exports = AccountsBoxHeader;
